import * as yup from 'yup'

import {
  requiredString
} from '../yup/schemas.js'
import { VALIDATION } from '../constants.js'

const loginSchema = yup.object({
  password: requiredString.matches(VALIDATION.REGEXP.PASSWORD, VALIDATION.MESSAGES.PASSWORD),
  email: requiredString.email().toLowerCase()
}).objectRequired()

const forgotPasswordSchema = { front: loginSchema.pick(['email']), back: loginSchema.pick(['email']) }
const resetPasswordSchema = { front: loginSchema.pick(['password']), back: loginSchema.pick(['password']) }

const loginSchemas = { front: loginSchema, back: loginSchema }

const tokenSchemas = {
  back: yup.object({ authorization: requiredString.startsWith('Bearer ') })
}
const optionalTokenSchemas = {
  back: yup.object({ authorization: yup.string().startsWith('Bearer ') })
}

export default {
  login: loginSchemas,
  token: tokenSchemas,
  optionalToken: optionalTokenSchemas,
  forgotPassword: forgotPasswordSchema,
  resetPassword: resetPasswordSchema
}
